module.exports = __webpack_public_path__ + "static/media/pla_gas_bot_sto.04cc9a64.png";